import { SpinningLoader } from '@vallourec-ui/vallourec-ui'
import React from 'react'

import { OverlayContainer } from './style'

const StyledLoadingOverlay: React.FC = () => {
  return (
    <OverlayContainer>
      <SpinningLoader />
    </OverlayContainer>
  )
}

export default StyledLoadingOverlay
